import { IMAGES_BASE_URL } from "@/lib/config";
import { capitalizeCityName } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { ImageWithFallback } from "../ui/fallbackImage";
import type { Course } from "@/services/golfClubService";
import { IonItem } from "@ionic/react";

type CourseItemProps = {
  course: Course;
  onSelect: () => void;
  showCourseCount?: boolean;
  showDistance?: boolean;
  showChevron?: boolean;
}

const FacilityListItem = ({
  course,
  onSelect,
  showCourseCount = false,
  showDistance = false,
  showChevron = false,
}: CourseItemProps) => {
  const { t } = useTranslation('MGP');
  return (
    <IonItem
      color="rounded-none border-b my-2"
      onClick={onSelect}
      style={{
        '--padding-start': '0px',
        '--padding-end': '0px'
      }}
    >
      <ImageWithFallback
        alt={`${course.name} photo`}
        fallbackImage="/assets/images/course_fallback.webp"
        src={`${IMAGES_BASE_URL}/${course.id}.jpg`}
        className="size-16 p-1 mr-1 shrink-0 overflow-hidden object-cover rounded-md"
      />
      <div>
        <span className="font-semibold text-base">{course.name}</span>
        <div className="text-sm text-muted-foreground">{capitalizeCityName(course.city)}, {course.country}</div>
        <div className="text-xs font-medium">
          {course.courses && course.courses.length > 1 && <span>{course.courses.length + ' ' + t('courses')}</span>}
          {course.courses && course.courses.length > 1 && course.distance && (<span className="mx-1">•</span>)}
          <span className="mr-1">{course.distance ? course.distance + ' km' : ''}</span>
        </div>
      </div>

    </IonItem>
  );
};

export default FacilityListItem;
